module.exports = __webpack_public_path__ + "img/user.b4c69d8d.svg";